module.exports = __webpack_public_path__ + "img/Precalificacion.32747d17.svg";